import { isEmpty } from 'lodash'
import { FETCH_PERSON_FAIL, FETCH_PERSON_SUCCESS, FETCH_PERSON_LOADING } from '../actions/types'

const INITIAL_STATE = {
  loading: false,
  fail: false,
  data: null
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FETCH_PERSON_LOADING:
      return { fail: false, loading: true, data: null }

    case FETCH_PERSON_SUCCESS:
      const data = isEmpty(action.payload) ? null : action.payload[0]
      return { fail: false, loading: false, data }

    case FETCH_PERSON_FAIL:
      return { fail: true, loading: false, data: null }

    default:
      return state
  }
}
